/*
// структура:
auth = {
    token: "eyJ0eXAiOiJKV1Q...",
    url: "https://auth.k-gorod.ru:9443/constructor",
    isGuest: false
}

// Примеры использования:

// 1. Удалить ключи
updateAuth({
    url: undefined, // удалит ключ url
    isGuest: undefined // удалит ключ isGuest
});

// 2. Заменить значения ключей
updateAuth({
    token: "новый_токен",
    url: "https://new-url.com",
    isGuest: true
});

// 3. Добавить новые ключи
updateAuth({
    refreshToken: "новый_рефреш_токен",
    expires: 1234567890
});

// 4. Смешанные операции
updateAuth({
    url: undefined, // удалить
    token: "обновлённый_токен", // обновить
    newField: "новое_значение" // добавить
});
*/

// Функция для получения данных из LocalStorage
export function getAuth() {
    try {
        const stored = localStorage.getItem('auth');
        return stored ? JSON.parse(stored) : false;
    } catch (e) {
        return false;
    }
}

// Функция для сохранения данных в LocalStorage
export function setAuth(authData) {
    try {
        localStorage.setItem('auth', JSON.stringify(authData));
    } catch (e) {
        console.error('Ошибка при сохранении auth в LocalStorage:', e);
    }
}

// Универсальная функция для работы с auth
export function updateAuth(updates) {
    const auth = getAuth() || {};

    for (const [key, value] of Object.entries(updates)) {
        if (value === undefined) {
            // Удаляем ключ, если значение undefined
            delete auth[key];
        } else {
            // Обновляем/добавляем ключ
            auth[key] = value;
        }
    }

    setAuth(auth);
    return auth;
}

// Функция для получения isGuest
export function getIsGuest() {
    const auth = getAuth();
    return auth ? (auth.isGuest !== undefined ? auth.isGuest : true) : true;
}